module.exports = __webpack_public_path__ + "static/media/jihaoxuanzhong@3x.1a89eba6.png";